module.exports = __webpack_public_path__ + "static/img/combin.1a784edb.png";